import { createFileRoute } from '@tanstack/react-router';
import parse from 'html-react-parser';
import { AccordionGroup, TotalsCard, Typography } from '@maia/ui';
import { getInsuranceOptions } from '../../../../features/insurance/insurance/queryOptions';
import { InsuranceInformationCard } from '../../../../features/insurance/insurance/insurance-information-card';
import { ContractInformationCard } from '../../../../features/insurance/insurance/contract-information-card';
import { formatCurrency } from '@maia/utils';
import { ObjectInformationCard } from '../../../../features/insurance/insurance/object-information-card';
import { CoveragesInformationCard } from '../../../../features/insurance/insurance/coverages-information-card';

export const Route = createFileRoute(
  '/_authenticated/insurances/$guid/_layout/',
)({
  component: Page,
  loader: ({ context: { queryClient }, params: { guid } }) =>
    queryClient.ensureQueryData(getInsuranceOptions(guid)),
});

function Page() {
  const data = Route.useLoaderData();

  return (
    <>
      <div className="col-span-full">
        <ContractInformationCard insurance={data} />
      </div>

      {!!data.specs.length && (
        <div className="col-span-full">
          <InsuranceInformationCard insurance={data} />
        </div>
      )}

      {!!data.object?.specs && (
        <div className="col-span-full">
          <ObjectInformationCard insurance={data} />
        </div>
      )}

      {!!data.coverages.length && (
        <div className="col-span-full">
          <CoveragesInformationCard insurance={data} />
        </div>
      )}

      {!!data.clauses && (
        <div className="col-span-full">
          <AccordionGroup
            title="Clausules"
            childs={data.clauses.map((clause) => ({
              title: clause.name,
              content: <Typography>{parse(clause.content)}</Typography>,
            }))}
          />
        </div>
      )}
      <div className="col-start-6 col-end-13">
        <TotalsCard
          totalPremium={formatCurrency(data.price.premiumAfterTax)}
          insuranceTax={formatCurrency(data.price.tax)}
          items={[]}
          billingUnit={data.customer.billingUnit}
        />
      </div>
    </>
  );
}
